module.exports = __webpack_public_path__ + "img/skillset-tool-2.4b490db8.png";